export default {"src":"/_next/static/media/Rootz.9ce225e7.svg","height":200,"width":400,"blurWidth":0,"blurHeight":0};